import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css'; // Import the AOS CSS file
import ClientSwiper from './ClientSwiper';
import MovingIcon from './MovingIcon';
import FormComponent from './FormComponents';

const Clients = ({ whatsapp }) => {
   

    return (
        <div className='mt-14'>
            <div data-aos="fade-down" data-aos-easing="linear" data-aos-duration="500" data-aos-once={true} data-aos-delay="0">
                <div data-aos="fade-zoom-in" data-aos-easing="linear" className='mt-4 text-3xl font-bold text-center text-main'>לקוחות ממליצים</div>
                <div data-aos="fade-zoom-in" data-aos-easing="linear" className="h-[1px] w-[260px] mx-auto mt-4 bg-main"></div>
                <div>
                    <ClientSwiper />
                </div>
            </div>

            <div data-aos="fade-zoom-in" data-aos-easing="linear" className="h-[1px] w-[85%] mx-auto mt-8  bg-main"></div>
            <div className='mt-8 px-2 text-3xl font-bold text-center text-main' data-aos="flip-right" data-aos-easing="linear" data-aos-duration="700" data-aos-once={true} data-aos-delay="0">לקביעת תור לחצו כאן</div>
            <div data-aos="flip-right" data-aos-easing="linear" data-aos-duration="700" data-aos-once={true} data-aos-delay="0">
                <MovingIcon whatsapp={whatsapp} />
            </div>
            <div data-aos="fade-zoom-in" data-aos-easing="linear" className="h-[1px] w-[85%] mx-auto mt-8  bg-main"></div>
            {/* <div className='mt-8 px-2 text-3xl font-bold text-center text-main'>השאירו פרטים ונחזור אליכם</div>
      <FormComponent/> */}
        </div>
    );
};

export default Clients;
